function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10.5,
  cy: 10.5,
  r: 9.5,
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.738 4.159l.957 2.946a1.75 1.75 0 001.664 1.21h3.098a.25.25 0 01.147.452l-2.506 1.82a1.75 1.75 0 00-.636 1.957l.958 2.946a.25.25 0 01-.385.28l-2.506-1.821a1.75 1.75 0 00-2.058 0l-2.506 1.82a.25.25 0 01-.385-.279l.958-2.946a1.75 1.75 0 00-.636-1.957l-2.506-1.82a.25.25 0 01.147-.453H7.64a1.75 1.75 0 001.664-1.209l.957-2.946a.25.25 0 01.476 0z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgLoyalty = function SvgLoyalty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoyalty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loyalty.c5a347de.svg";
export { ForwardRef as ReactComponent };